import request from 'sb-request'
import { getGqlQuery } from 'common/helpers'
import { reducers } from 'redux/core'


const fetch = ({ noteId, limit = 5, excludeProductId = null } = {}) => {
  reducers.view.noteRecommendationsModal.setFetching(true)

  const topProductsQuery = getGqlQuery('topProducts', {
    limit,
    excludeProductId,
  })

  return request.post('graphql?name=noteById', {
    body: {
      query: `{
        noteById(noteId: ${noteId}) {
          id
          products: ${topProductsQuery} {
            id
            url
            sex
            img
            type
            name
            brand
            labels
            category
            upchargePrice  
          }
        }
      }`,
    },
    modifyResult: ({ noteById: { id, products } }) => ({
      id,
      products,
    }),
  })
    .then(
      (result) => reducers.view.noteRecommendationsModal.set(result),
      () =>
        reducers.view.noteRecommendationsModal.set({
          id: noteId,
          products: [],
        }),
    )
}


export default {
  fetch,
}
